import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, ModalFooter } from "reactstrap";
import moment from "moment";
import ModalImage from "react-modal-image";
import Flatpickr from "react-flatpickr";
import { isEmpty, clone } from "lodash";

import Board from "react-trello";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Select from "react-select";
import CardBoard from "./CardBoard";
import classnames from "classnames";
import DeleteModal from "../../../Components/Common/DeleteModal";

// Import actions
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { api } from "../../../config";
import { Link } from "react-router-dom";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import ModalInputFile from "../../../Components/ModalInputFile";
import CurrencyInput from "react-currency-input-field";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { getLegalPermission as onGetLegalPermissions, addNewLegalPermission as onAddNewLegalPermissions, updateLegalPermission as onUpdateLegalPermissions, deleteLegalPermission as onDeleteLegalPermissions, resetLegalPermissionState, getLegalPermissionLoading } from "../../../store/legalPermission/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../helpers/utils/handleValidDateTime";
import { getDepartment, resetDepartmentState } from "../../../store/department/action";
import { getLegalityDocument, resetLegalityDocumentState } from "../../../store/legalityDocument/action";
import { ButtonPrintF4, PrintDocF4 } from "./PrintDocF4";
import { useAsyncDebounce, useExpanded, useFilters, useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import ExportDoc from "../../../Components/Common/ExportDoc";
import SimpleBar from "simplebar-react";

const LegalPermission = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [legalityPermissionDoc, setLegalityPermissionDoc] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, maritals, maritalLoading, isLegalPermissionCreated, legalPermissions, companies, companyLoading, clientLoading, clients, branches, branchLoading, loading, legalStatus, departments, departmentLoading, legalityDocuments, loadingLegalityDocument, budgets, budgetLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    legalPermissions: state.LegalPermission.legalPermissions,
    loading: state.LegalPermission.loading,
    isLegalPermissionCreated: state.LegalPermission.isLegalPermissionCreated,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    legalStatus: state.LegalStatus.legalStatus,
    maritalLoading: state.Marital.loading,
    maritals: state.Marital.maritals,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    legalityDocuments: state.LegalityDocument.legalityDocuments,
    loadingLegalityDocument: state.LegalityDocument.loading,
  }));

  const [assetFiles, setAssetFiles] = useState([]);
  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const printRef = useRef(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);
  const [dataPermisionModal, setDataPermissionModal] = useState(null);
  // const [selectCategoryPermission, setSelectCategoryPermission] = useState(null);

  const [budgetList, setBudgetList] = useState([]);
  const [dataBoard, setDataBoard] = useState({ lanes: [] });
  const [id, setId] = useState(null);
  const [modal, setModal] = useState(false);
  //
  const [modalTrans, setModalTrans] = useState(false);
  const [expense, setExpense] = useState([]);
  const [printTransDoc, setPrintTransDoc] = useState([]);
  const expanseDataRef = useRef([]);
  //
  const [modalAccPayable, setModalAccPayable] = useState(false);
  const [legalPermission, setLegalPermission] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [info, setInfo] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [legalityDocumentList, setLegalityDocumentList] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [legalPermissionFiles, setLegalPermissionFiles] = useState([]);

  const [modalMailing, setModalMailing] = useState(false);
  const [legalStatusList, setLegalStatusList] = useState([]);
  const [legalPermissionList, setLegalPermissionList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentSelect, setDepartmentSelect] = useState(null);

  const [modalPrint, setModalPrint] = useState(false);
  const [printType, setPrintType] = useState(null);

  const [activeMenuTab, setActiveMenuTab] = useState("1");
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");

  const searchHandleLegalPermission = (searchTerm) => {
    if (searchTerm === "") {
      dispatch(onGetLegalPermissions({ companyId: companySelected.value, branchId: branchSelected?.value }));
    } else {
      let result = legalPermissions.filter((o) => o.legal_per_document?.name.toLowerCase().includes(searchTerm.toLowerCase()));
      setLegalPermissionList(result);
    }
  };

  const searchListTrans = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el.transaction_reff ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.supplier ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.branch ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  useEffect(() => {
    if (companySelected && branchSelected) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setDepartmentSelect({
        label: obj?.data?.user?.user_department?.name,
        value: obj?.data?.user?.user_department?.id,
      });
      validation.setFieldValue("department", {
        label: obj?.data?.user?.user_department?.name,
        value: obj?.data?.user?.user_department?.id,
      });

      dispatch(resetLegalPermissionState());
      dispatch(onGetLegalPermissions({ companyId: companySelected.value, branchId: branchSelected?.value }));
      dispatch(resetLegalStatusState());
      dispatch(getLegalStatus({ type: "izin" }));
      setIsSearch(true);

      handleGetDepartement(companySelected.value);
      dispatch(resetLegalityDocumentState());
      dispatch(getLegalityDocument({ companyId: companySelected.value, status: 2 }));
      handleGetBudget(companySelected.value, branchSelected.value);
    }
  }, [companySelected, branchSelected]);

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setIsEdit(false);
      setLegalPermission(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTrans = useCallback(() => {
    if (modalTrans) {
      setModalTrans(false);
    } else {
      setModalTrans(true);
    }
  }, [modalTrans]);

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  const toggleMailing = useCallback(() => {
    if (modalMailing) {
      setModalMailing(false);
      setDataPermissionModal(null);
      validationMailing.resetForm();
    } else {
      setModalMailing(true);
    }
  }, [modalMailing]);

  const togglePrint = useCallback(
    (type) => {
      if (modalPrint) {
        setModalPrint(false);
        setPrintType(null);
        setDataPermissionModal(null);
      } else {
        setModalPrint(true);
        setPrintType(type);
      }
    },
    [modalPrint]
  );

  useEffect(() => {
    if (isLegalPermissionCreated) {
      dispatch(onGetLegalPermissions({ companyId: companySelected.value, branchId: branchSelected?.value }));
    }
  }, [isLegalPermissionCreated]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    setCompanyList(data);
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    setBranchList(data);
  }, [branches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    departments.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    setDepartmentList(data);
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var data = [];
      var opt = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setLegalStatusList(data);
    }
  }, [legalStatus]);

  useEffect(() => {
    var data = [];
    var opt = [];
    legalityDocuments.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    setLegalityDocumentList(data);
  }, [legalityDocuments]);

  const handleSelectFile = (file) => {
    setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  useEffect(() => {
    let filteredLegalPermissions = legalPermissions;
    if (activeTypeTab !== "all") {
      filteredLegalPermissions = legalPermissions.filter((legal) => legal.legal_per_status_legal.id === activeTypeTab);
    }
    if (legalPermissions.length) {
      setLegalPermissionList(filteredLegalPermissions.map((el) => ({ ...el, isChecked: false })));
      const data = filteredLegalPermissions[filteredLegalPermissions.length - 1];
      if (info.id) {
        for (const obj of legalPermissions) {
          if (obj.id === info.id) {
            setInfo(obj);
          }
        }
      } else {
        setInfo(data);
      }
    } else {
      setLegalPermissionList([]);
      setInfo({});
    }
  }, [legalPermissions]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "legal_per_document",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "targetat",
        label: "Target",
        isSelected: true,
        data: [],
      },
      {
        id: "terhutang",
        label: "Terhutang",
        isSelected: true,
        data: [],
      },
      {
        id: "terbayar",
        label: "Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "sisaBayar",
        label: "Sisa Bayar",
        isSelected: true,
        data: [],
      },
    ];

    if (legalPermissionList.length > 0) {
      legalPermissionList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "legal_per_document") {
                const name = value?.name ?? "";
                const status = data.legal_per_status_legal?.name ?? "";
                doc.data.push(`${name} - ${status}`);
              } else if (doc.id === "targetat") {
                doc.data.push(handleValidDate(value));
              } else {
                doc.data.push(value ?? "-");
              }
            }

            if (key === "legal_per_trans") {
              const terhutangDoc = dataDoc.find((d) => d.id === "terhutang");
              const terbayarDoc = dataDoc.find((d) => d.id === "terbayar");
              const sisaBayarDoc = dataDoc.find((d) => d.id === "sisaBayar");
              let price = (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
              let amount = (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

              terhutangDoc.data.push(currencyFormat(price));
              terbayarDoc.data.push(currencyFormat(amount));
              sisaBayarDoc.data.push(currencyFormat(price - amount));
            }
          });
        }
      });
    }

    setLegalityPermissionDoc(dataDoc);
  }, [legalPermissionList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  //set card
  useEffect(() => {
    let l = [];

    legalStatus.forEach((el) => {
      l.push({
        id: el.id.toString(),
        sortOrder: el.sort_order,
        title: el.name,
        style: {
          width: 330,
        },
        cards: [],
      });
    });

    l.forEach((el) => {
      legalPermissionList.forEach((e) => {
        if (e.statusLegalId !== null) {
          if (el.id.toString() === e.statusLegalId.toString()) {
            el.cards.push({
              id: e.id.toString(),
              description: e.description ?? "",
              image: e.image ?? "",
              data: e ?? null,
            });
          }
        }
      });
    });

    setDataBoard((val) => {
      return {
        ...val,
        lanes: l,
      };
    });
  }, [legalStatus, legalPermissionList]);

  const handleSubmitLoading = useCallback(
    (id) => {
      setId(id);
    },
    [setId]
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      client: (legalPermission && legalPermission.client) || clientSelected,
      company: (legalPermission && legalPermission.company) || companySelected,
      branch: (legalPermission && legalPermission.branch) || branchSelected,
      department: (legalPermission && legalPermission.department) ?? "",
      name: (legalPermission && legalPermission.name) ?? "",
      pic: (legalPermission && legalPermission.pic) ?? "",
      institution: (legalPermission && legalPermission.institution) ?? "",
      legal_status: (legalPermission && legalPermission.legal_status) ?? "",
      legal_doc: (legalPermission && legalPermission.legal_doc) ?? "",
      targetat: (legalPermission && legalPermission.targetat) ?? "",
      startat: (legalPermission && legalPermission.startat) ?? "",
      description: (legalPermission && legalPermission.description) ?? "",
      mailing: (legalPermission && legalPermission.mailing) || {},
    },
    validationSchema: Yup.object({
      client: Yup.object().required("Please Select Klient").nullable(true),
      company: Yup.object().required("Please Select Perusahaan").nullable(true),
      branch: Yup.object().required("Please Select Cabang").nullable(true),
      department: Yup.object().required("Please Select Department").nullable(true),
      name: Yup.string().required("Please enter Nama").nullable(true),
      legal_status: Yup.object().required("Please Select Status").nullable(true),
      legal_doc: Yup.object().required("Please Select Kategori").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateContact = {
          id: legalPermission ? legalPermission.id : 0,
          clientId: values.client.value ?? null,
          companyId: values.company.value ?? null,
          branchId: values.branch.value ?? null,
          departmentId: values.department.value ?? null,
          name: values.name,
          statusLegalId: values.legal_status.value ?? null,
          legalityDocumentId: values.legal_doc.value ?? null,
          startat: values.startat,
          targetat: values.targetat,
          pic: values.pic,
          institution: values.institution,
          description: values.description,
          files: assetFiles.length > 0 ? assetFiles : [],
        };
        // update Contact
        dispatch(onUpdateLegalPermissions(updateContact));
        validation.resetForm();
      } else {
        const newContact = {
          clientId: values.client.value ?? null,
          companyId: values.company.value ?? null,
          branchId: values.branch.value ?? null,
          departmentId: values.department.value ?? null,
          name: values.name,
          statusLegalId: values.legal_status.value ?? null,
          legalityDocumentId: values.legal_doc.value ?? null,
          startat: values.startat,
          targetat: values.targetat,
          pic: values.pic,
          institution: values.institution,
          description: values.description,
          files: assetFiles.length > 0 ? assetFiles : [],
        };

        // save new Contact
        dispatch(onAddNewLegalPermissions(newContact));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `PERIZINAN ${info?.legal_per_document?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
    }),
    onSubmit: (values) => {
      dispatch(getLegalPermissionLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegalPermissions(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const validationMailing = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (Object.keys(values).length > 0) {
        let files = [];
        if (Array.isArray(dataPermisionModal.legal_per_file)) {
          for (const f of dataPermisionModal.legal_per_file) {
            files.push({ filename: f.filename, originalname: f.originalname });
          }
        }
        const dataNew = { ...dataPermisionModal, files: files, mailing: values };
        dispatch(onUpdateLegalPermissions(dataNew));
        toggleMailing();
      }
    },
  });

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const handleUpdate = useCallback((data) => {
    let files = [];
    if (Array.isArray(data.legal_per_file)) {
      for (const f of data.legal_per_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
    }
    setAssetFiles(files);

    setLegalPermission({
      id: data.id,
      client: data.legal_per_client && { label: data.legal_per_client.name, value: data.legal_per_client.id },
      company: data.legal_per_company && { label: data.legal_per_company.name, value: data.legal_per_company.id },
      branch: data.legal_per_branch && { label: data.legal_per_branch.name, value: data.legal_per_branch.id },
      department: data.legal_per_department && {
        label: data.legal_per_department.name,
        value: data.legal_per_department.id,
      },
      name: data.name,
      legal_status: data.legal_per_status_legal && {
        label: data.legal_per_status_legal.name,
        value: data.legal_per_status_legal.id,
      },
      legal_doc: data.legal_per_document && {
        label: data.legal_per_document.name,
        value: data.legal_per_document.id,
      },
      targetat: data.targetat,
      startat: data.startat,
      pic: data.pic,
      institution: data.institution,
      description: data.description,
    });

    setIsEdit(true);
    toggle();
  }, []);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalPermissionList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalPermissionList(updated);
    setIsCheckAll(allChecked);
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = (legal) => {
    setLegalPermission(legal);
    setDeleteModal(true);
  };

  const handleDeleteLegal = () => {
    if (legalPermission) {
      dispatch(onDeleteLegalPermissions(legalPermission));
      setDeleteModal(false);
    }
  };

  const columns = useMemo(() => {
    return [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          let price = (data.legal_permission_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          let amount = (data.legal_permission_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={legalPermissionList.find((x) => x.id === data.id).isChecked}
                onChange={() => {
                  const updatedData = legalPermissionList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setLegalPermissionList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      setDataPermissionModal(data);
                      if (data.mailing && typeof data.mailing === "object" && Object.keys(data.mailing).length > 0) {
                        validationMailing.setValues({
                          ...data.mailing,
                        });
                      }
                      toggleMailing();
                    }}
                  >
                    <i className="ri-newspaper-line align-bottom me-1 fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleUpdate(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      data.statusId = 3;
                      onClickDelete(data);
                    }}>
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
                  <DropdownMenu container="body">
                    <DropdownItem
                      onClick={() => {
                        setDataPermissionModal(data);
                        togglePrint("print-siteplan");
                      }}
                    >
                      SITEPLAN
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setDataPermissionModal(data);
                        togglePrint("print-peli-banjir");
                      }}
                    >
                      PELI BANJIR
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setDataPermissionModal(data);
                        togglePrint("print-jembatan");
                      }}
                    >
                      PEKERJAAN TAMBAH
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setDataPermissionModal(data);
                        togglePrint("print-rumija");
                      }}
                    >
                      RUMIJA
                    </DropdownItem>
                    {/* <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-sk-penetapan");
                }}>
                SK PENETAPAN
              </DropdownItem> */}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
                <button
                  className={"btn me-2 btn-sm btn-soft-info"}
                  onClick={() => {
                    setInfo(data);
                    toggleAccPayable();
                  }}
                >
                  <i className="ri-file-list-3-line fs-12 label-icon align-middle me-1"></i> INVOICE
                </button>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "legal_per_document.name",
        filterable: true,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          let status;
          switch (data?.legal_per_status?.name) {
            case "DRAFT":
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_per_status?.name} </span>;
              break;
            case "ACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.legal_per_status?.name} </span>;
              break;
            case "INACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.legal_per_status?.name} </span>;
              break;
            default:
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_per_status?.name} </span>;
              break;
          }
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                setInfo(data);
              }}
            >
              <div className="mb-0 fw-semibold">{data?.legal_per_document?.name || "NO NAME"}</div>
              <div className="hstack gap-2">
                <span className="badge fw-normal fs-9 bg-soft-info text-dark">{data?.legal_per_status_legal?.name}</span>
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Dinas Terkait",
        accessor: "institution",
        filterable: true,
        Cell: (cell) => {
          return <div>{cell.value}</div>;
        },
      },
      {
        Header: "PIC",
        accessor: "pic",
        filterable: true,
        Cell: (cell) => {
          return <div>{cell.value}</div>;
        },
      },
      {
        Header: "Tgl Mulai",
        accessor: "startat",
        filterable: true,
        Cell: (cell) => {
          return <div>{handleValidDate(cell.value)}</div>;
        },
      },
      {
        Header: "Tgl Selesai",
        accessor: "targetat",
        filterable: true,
        Cell: (cell) => {
          return <div>{cell.value ? handleValidDate(cell.value) : "-"}</div>;
        },
      },

      {
        id: "Leadtime",
        Header: "Lama Proses",
        accessor: "",
        filterable: true,
        Cell: (cell) => {
          const o = cell.row.original;
          if (o.startat) {
            const berkasPlaced = moment(o.startat);
            const orderCompleted = o.targetat ? moment(o.targetat) : moment();
            const durationBerkas = orderCompleted.diff(berkasPlaced);
            const leadTimeBerkas = moment.duration(durationBerkas);

            const diffDays = orderCompleted.diff(berkasPlaced, 'days');

            return <div>{`${diffDays} Hari`}</div>;
            //return <div>{`${leadTimeBerkas.months()} Bulan, ${leadTimeBerkas.days()} Hari, ${leadTimeBerkas.hours()} Jam, ${leadTimeBerkas.minutes()} Menit`}</div>;
          }
          else {
            return "-"
          }
        },
      },
      {
        id: "Status",
        Header: "Status",
        accessor: "legal_per_status_legal.name",
        filterable: true,
        Cell: (cell) => {
          return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
        },
      },
      {
        id: "Terhutang",
        Header: "Terhutang",
        accessor: (data) => (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (data) => {
          let payable = (data.row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          return (
            <div>
              <span
                onClick={() => {
                  const dataRow = data.row.original;
                  expanseDataRef.current = dataRow.legal_per_trans || [];
                  setInfo(dataRow);
                  setExpense(dataRow.legal_per_trans || []);
                  toggleTrans();
                }}
                className="fw-semibold text-info"
              >
                {currencyFormat(payable)}
              </span>
            </div>
          );
        },
      },
      {
        id: "Terbayar",
        Header: "Terbayar",
        accessor: (data) => (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (data) => {
          let price = (data.row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          let amount = (data.row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          return (
            <div>
              <span
                onClick={() => {
                  const dataRow = data.row.original;
                  expanseDataRef.current = dataRow.legal_per_trans || [];
                  setInfo(dataRow);
                  setExpense(dataRow.legal_per_trans || []);
                  toggleTrans();
                }}
                className={amount >= price ? "fw-semibold text-success" : amount > 0 && amount < price ? "fw-semibold text-warning" : "fw-semibold text-danger"}
              >
                {currencyFormat(amount)}
              </span>
            </div>
          );
        },
      },
      {
        id: "SisaBayar",
        Header: "Sisa Bayar",
        accessor: (data) => (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) - (data.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
        filterable: true,
        Cell: (data) => {
          let price = (data.row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          let amount = (data.row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
          return (
            <div>
              <span
                onClick={() => {
                  const dataRow = data.row.original;
                  expanseDataRef.current = dataRow.legal_per_trans || [];
                  setInfo(dataRow);
                  setExpense(dataRow.legal_per_trans || []);
                  toggleTrans();
                }}
                className={amount >= price ? "fw-semibold text-success" : amount > 0 && amount <= price ? "fw-semibold text-warning" : "fw-semibold text-danger"}
              >
                {currencyFormat(price - amount < 0 ? 0 : price - amount)}
              </span>
            </div>
          );
        },
      },

      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
        Cell: (cell) => {
          return <div>{cell.value}</div>;
        },
      },
    ];
  }, [handleUpdate, legalPermissionList, userRole, userType, isCheckAll]);

  const [searchValue, setSearchValue] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalPermissionList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalPermissionList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const datas = useMemo(() => {
    return legalPermissionList;
  }, [legalPermissionList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: datas,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department", "Status", "Area", "Terhutang", "Terbayar", "SisaBayar"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const count = preGlobalFilteredRows.length;

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const toggleMenuTab = (tab) => {
    if (activeMenuTab !== tab) {
      setActiveTab("1");
      setActiveTypeTab("all");
      setActiveMenuTab(tab);
    }
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setPageIdx(0);
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredLegalPermissions = legalPermissions;
      if (type !== "all") {
        filteredLegalPermissions = legalPermissions.filter((legal) => legal.legal_per_status_legal.id === type);
      }
      setLegalPermissionList(filteredLegalPermissions);
    }
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintTransDoc(dataDoc);
  }, [expense]);

  const components = {
    Card: (props) => (
      <CardBoard
        idCard={id}
        handleSubmitLoading={handleSubmitLoading}
        isLoadingLegalPermission={loading}
        handleToggleUpdate={(data) => {
          handleUpdate(data);
        }}
        handleToggleMailing={(data) => {
          setDataPermissionModal(data);
          if (data.mailing && typeof data.mailing === "object" && Object.keys(data.mailing).length > 0) {
            validationMailing.setValues({
              ...data.mailing,
            });
          }
          toggleMailing();
        }}
        handleToggleMailingPrint={(data, type) => {
          setDataPermissionModal(data);
          togglePrint(type);
        }}
        {...props}
      />
    ),
  };

  function handleFilter() {
    // let startat = "";
    // let endat = "";
    // let datearr = filterDate?.split(" to ");
    // if (datearr) {
    //   startat = datearr[0];
    //   endat = datearr[1] ? datearr[1] : datearr[0];
    // }
    // var status = statusActive.value ? statusActive.value : "";
    // const param = {
    //   title: searchValue,
    //   startat: startat,
    //   endat: endat,
    //   status: status,
    // };
    // dispatch(onGetLegalityDocuments(param));
  }

  const handleResetFilter = () => {
    // setFilterDate(null);
    // setLegalityDocumentList([]);
    // setSearchValue("");
    // setStatusActive([]);
    // setGlobalFilter(undefined);
    // dispatch(resetLegalityDocumentState());
    // dispatch(onGetLegalityDocuments());
  };

  const [expandedRowId, setExpandedRowId] = useState(null);

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };


  document.title = "Perizinan | Enterprise Resources Planning";

  return (
    <React.Fragment>
      <div className="page-content">
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegal} onCloseClick={() => setDeleteModal(false)} />
        <Container fluid>
          <BreadCrumb title="Pertanahan" pageTitle="Perizinan" loading={loading}>
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegal") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  toggle();
                }}
              >
                <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              <ExportDoc data={legalityPermissionDoc} />
            </div>
          </BreadCrumb>
          <div>
            <Card>
              <CardBody className="pt-1 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeMenuTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleMenuTab("1");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> TABLE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeMenuTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleMenuTab("2");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> PROGRESS
                      </NavLink>
                    </NavItem>
                  </Nav>
                  {/* <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => toggleTab("1", "all")} href="#">
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem> */}

                  {/* {legalStatus.map((o, i) => (
                      <NavItem key={i}>
                        <NavLink
                          className={classnames({ active: activeTab === i + 2 }, "fw-semibold")}
                          onClick={() => {
                            toggleTab(i + 2, o.id);
                          }}
                          href="#"
                        >
                          <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> {o.name}
                        </NavLink>
                      </NavItem>
                    ))} */}
                </Nav>

                <Row className="mb-3">
                  <CardBody className="pb-0 mb-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[25, 50, 100, 150, 250, 500, 1000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>

                        <Col sm={8}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setLegalPermissionList(legalPermissionList.map((el) => ({ ...el, isChecked: false })));
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                                searchHandleLegalPermission(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>

                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button type="button" className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100" onClick={handleFilter}>
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button type="button" className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100" onClick={handleResetFilter}>
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
              </CardBody>
            </Card>
            <div>
              {activeMenuTab === "1" ? (
                <Row>
                  <Col lg={9} style={{ position: "relative" }}>
                    <Card style={{ position: "sticky", top: "94px" }}>
                      <CardBody>
                        <div className="table-responsive table-card mb-1">
                          <Table hover {...getTableProps()} className="align-middle table-nowrap">
                            <thead className="bg-soft-info">
                              {headerGroups.map((headerGroup, index) => (
                                <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                                  {headerGroup.headers.map((column, i) => (
                                    <th key={i} {...column.getSortByToggleProps()}>
                                      {column.render("Header")}
                                      {generateSortingIndicator(column)}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {page.map((row) => {
                                prepareRow(row);
                                let price = (row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
                                let amount = (row.original.legal_per_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

                                return (
                                  <Fragment key={row.id} {...row.getRowProps()} >
                                    <tr className="cursor-pointer" onClick={() => {
                                      handleRowClick(row.id);
                                      setInfo(row.original);
                                    }}>
                                      {row.cells.map((cell, i) => (
                                        <td {...cell.getCellProps()} key={i}>
                                          {cell.render("Cell")}
                                        </td>
                                      ))}
                                    </tr>
                                    {expandedRowId === row.id && (
                                      <tr>
                                        <td></td>
                                        <td colSpan="7" className="cursor-pointer" onClick={() => {
                                          const dataRow = row.original;
                                          expanseDataRef.current = dataRow.legal_per_trans || [];
                                          setExpense(dataRow.legal_per_trans || []);
                                          toggleTrans();
                                        }}>
                                          <div className="d-flex gap-5">
                                            <div>
                                              <strong>Terbayar:</strong>
                                              <p className="fw-semibold text-success">{currencyFormat(row.values.Terbayar)}</p>
                                            </div>
                                            <div>
                                              <strong>Terhutang:</strong>
                                              <p className="fw-semibold text-info">{currencyFormat(row.values.Terhutang)}</p>
                                            </div>
                                            <div>
                                              <strong>Sisa Bayar:</strong>
                                              <p className="fw-semibold text-danger">{currencyFormat(price - amount < 0 ? 0 : price - amount)}</p>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </Fragment>

                                );
                              })}
                            </tbody>
                          </Table>
                        </div>

                        <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                          <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                          <Col className="col-md-auto">
                            <div className="d-flex gap-1">
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  setPageIdx(pageIndex - 1);
                                  previousPage();
                                }}
                                disabled={!canPreviousPage}>
                                {"<"}
                              </Button>
                            </div>
                          </Col>
                          <Col className="col-md-auto d-none d-md-block">
                            Halaman {pageIndex + 1} dari {pageOptions.length}
                          </Col>
                          <Col className="col-md-auto">
                            <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                          </Col>
                          <Col className="col-md-auto">
                            <div className="d-flex gap-1">
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  setPageIdx(pageIndex + 1);
                                  nextPage();
                                }}
                                disabled={!canNextPage}>
                                {">"}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={3}>
                    <Card className="table-responsive">
                      <div className="card-body">
                        <table className="table align-middle table-nowrap mb-3">
                          <thead className="table-active">
                            <tr>
                              <th scope="col" className="p-2 pt-3 pb-3">
                                Dokumen:
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(info.legal_per_file || []).map((file, key) => {
                              let src;
                              return (
                                <tr
                                  key={key + "filehak"}
                                  className="cursor-pointer"
                                  onClick={() => {
                                    const typeFile = file.filename.split(".");
                                    if (typeFile[typeFile.length - 1] === "x-compressed") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "sheet") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "pdf") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else {
                                      //
                                    }
                                  }}
                                >
                                  <td>
                                    <div className="d-flex">
                                      <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                        <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                      </div>
                                      <div className="flex-grow-1 text-start">
                                        <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                        <p>{file.originalname}</p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <h6 className="fw-semibold mb-2">Keterangan</h6>
                        <p className="mb-4">{info.description ? info.description : "-"} </p>
                      </div>
                      <CardBody className="text-center">
                        <table className="table border table-responsive fs-13 mb-3">
                          <tbody>
                            <tr>
                              <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                INFORMASI LAINNYA
                              </td>
                            </tr>
                            <tr>
                              <td className="p-2">Perusahaan</td>
                              <td className="p-2">{info.legal_per_company && info.legal_per_company.name ? info.legal_per_company.name : "-"} </td>
                            </tr>
                            <tr>
                              <td className="p-2">Dibuat Oleh</td>
                              <td className="p-2">{info.legal_per_createdby && info.legal_per_createdby.name ? info.legal_per_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p-2">Diedit Oleh</td>
                              <td className="p-2">{info.legal_per_updatedby && info.legal_per_updatedby.name ? info.legal_per_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                <Board
                  data={dataBoard}
                  components={components}
                  // onBeforeCardDelete={(e) => {
                  //   e();
                  // }}
                  onDataChange={(e) => { }}
                  handleDragEnd={(cardId, sourceLaneId, targetLaneId, position) => {
                    let object = legalPermissions.find((obj) => obj.id.toString() === cardId.toString());
                    if (object.statusLegalId.toString() !== targetLaneId.toString()) {
                      const updateContact = { ...object, statusLegalId: Number(targetLaneId) };
                      dispatch(onUpdateLegalPermissions(updateContact));
                    }
                  }}
                />
              )}
            </div>
          </div>
        </Container>
      </div>

      <Modal id="addlegalPermissions" isOpen={modal} toggle={toggle} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          {isEdit ? "Edit" : "Tambah"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Row>
              <Col lg={4}>
                <Card>
                  {/* <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                    <h5 className="card-title mb-0">LegalPermissions Identity</h5>
                  </CardHeader> */}
                  <CardBody>
                    <div className="mb-3">
                      <Label htmlFor="client-field" className="form-label">
                        Grup Usaha&nbsp;
                        {clientLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="client"
                        value={validation.values.client}
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        placeholder="Pilih Grup Usaha"
                        onChange={(e) => {
                          validation.setFieldValue("client", e);
                        }}
                        options={clientList}
                      ></Select>
                      {validation.touched.client && validation.errors.client && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.client}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="company-field" className="form-label">
                        Perusahaan&nbsp;
                        {companyLoading ? (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        ) : (
                          ""
                        )}
                      </Label>
                      <Select
                        name="company"
                        value={validation.values.company}
                        placeholder="Pilih Perusahaan"
                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                        onChange={(e) => {
                          setDepartmentList([]);
                          dispatch(setBranchSelect(null));
                          dispatch(setCompanySelect(e));
                          validation.setFieldValue("branch", "");
                          validation.setFieldValue("department", "");
                          validation.setFieldValue("company", e);
                        }}
                        options={companyList}
                      ></Select>
                      {validation.touched.company && validation.errors.company && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.company}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="company-field" className="form-label">
                        Branch&nbsp;
                        {branchLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="branch"
                        value={validation.values.branch}
                        placeholder="Select Branch"
                        onChange={(e) => {
                          dispatch(setBranchSelect(e));
                          validation.setFieldValue("branch", e);
                        }}
                        options={branchList}
                      ></Select>
                      {validation.touched.branch && validation.errors.branch && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.branch}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="department-field" className="form-label">
                        Department&nbsp;
                        {departmentLoading && (
                          <Spinner color="primary" size="sm">
                            Loading...
                          </Spinner>
                        )}
                      </Label>
                      <Select
                        name="department"
                        value={validation.values.department}
                        placeholder="Select Department"
                        onChange={(e) => {
                          validation.setFieldValue("department", e);
                        }}
                        options={departmentList}
                      ></Select>
                      {validation.touched.department && validation.errors.department && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.department}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="legal_doc-field" className="form-label">
                        Kategori
                      </Label>
                      <Select
                        name="legal_doc"
                        value={validation.values.legal_doc}
                        placeholder="Select Kategori"
                        onChange={(e) => {
                          validation.setFieldValue("legal_doc", e);
                        }}
                        options={legalityDocumentList}
                      ></Select>
                      {validation.touched.legal_doc && validation.errors.legal_doc && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.legal_doc}
                        </small>
                      )}
                    </div>
                  </CardBody>
                </Card>
                {/* Text */}
              </Col>
              <Col lg={8}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="name">
                        Nama
                      </Label>
                      <Input type="text" className="form-control" id="name" placeholder="Isi Nama" name="name" value={validation.values.name ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.name && validation.errors.name ? true : false} />
                      {validation.touched.name && validation.errors.name && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.name}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="legal_status-field" className="form-label">
                        Status
                      </Label>
                      <Select
                        name="legal_status"
                        value={validation.values.legal_status}
                        placeholder="Select Status"
                        onChange={(e) => {
                          validation.setFieldValue("legal_status", e);
                        }}
                        options={legalStatusList}
                      ></Select>
                      {validation.touched.legal_status && validation.errors.legal_status && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.legal_status}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="pic">
                        PIC
                      </Label>
                      <Input type="text" className="form-control" id="pic" placeholder="Isi PIC" name="pic" value={validation.values.pic ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.pic && validation.errors.pic ? true : false} />
                      {validation.touched.pic && validation.errors.pic && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.pic}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="institution">
                        Dinas
                      </Label>
                      <Input type="text" className="form-control" id="institution" placeholder="Isi Dinas" name="institution" value={validation.values.institution ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.institution && validation.errors.institution ? true : false} />
                      {validation.touched.institution && validation.errors.institution && (
                        <small className="text-danger" type="invalid">
                          {validation.errors.institution}
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="startat-field" className="form-label">
                        Tanggal Mulai
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.startat ?? ""}
                        onChange={(obj, str) => {
                          validation.setFieldValue("startat", str);
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label Shop threebel htmlFor="targetat-field" className="form-label">
                        Tanggal Selesai
                      </Label>
                      <Flatpickr
                        name="date-picker"
                        className="form-control"
                        placeholder="Select end date"
                        options={{
                          enableTime: false,
                          altInput: true,
                          altFormat: "Y/m/d",
                          dateFormat: "Y/m/d",
                        }}
                        value={validation.values.targetat ?? ""}
                        onChange={(obj, str) => {
                          validation.setFieldValue("targetat", str);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="mb-3">
                  <Label htmlFor="description-field" className="form-label">
                    Description
                  </Label>
                  <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                </div>
                <Row>
                  <Col lg={12}>
                    <div className="mb-3 d-flex justify-content-between">
                      <Label htmlFor="taskFiles" className="form-label me-3">
                        Dokumen
                      </Label>
                      <button
                        type="button"
                        className="btn btn-sm btn-label btn-soft-success"
                        onClick={() => {
                          toggleMedia();
                        }}
                      >
                        <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                      </button>
                    </div>
                    {assetFiles.map((assetFile, i) => {
                      if (assetFile.isDeleted) {
                        return null;
                      } else {
                        return (
                          <div key={i} className="border-bottom mb-3">
                            <div className="d-flex justify-content-between mb-3 align-items-center">
                              <div className="me-2">
                                <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                              </div>
                              <div className="text-truncate">{assetFile.originalname}</div>
                              <div>
                                <Link
                                  to="#"
                                  className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                  onClick={(e) => {
                                    handleDeleteFile(assetFile);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </Col>
                </Row>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="light" id="close-modal" onClick={toggle}>
              Tutup
            </Button>
            <Button type="submit" color="success">
              <i className="ri-save-line align-bottom me-1"></i> Simpan
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* mailing modal */}
      <Modal id="showModal" isOpen={modalMailing} centered size="lg">
        <ModalHeader className="bg-light p-3" toggle={toggleMailing}>
          {!!isEdit ? `Edit ${dataPermisionModal?.legal_per_document?.name ?? "-"}` : `Tambah ${dataPermisionModal?.legal_per_document?.name ?? "-"}`}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationMailing.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            {dataPermisionModal && dataPermisionModal?.legalityDocumentId === 10 && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="nama-field" className="form-label">
                      Nama
                    </Label>
                    <Input name="nama" id="nama-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nama ?? ""} invalid={validationMailing.touched.nama && validationMailing.errors.nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jabatan-field" className="form-label">
                      Jabatan
                    </Label>
                    <Input name="jabatan" id="jabatan-field" className="form-control" placeholder="Isi Jabatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jabatan ?? ""} invalid={validationMailing.touched.jabatan && validationMailing.errors.jabatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat-field" className="form-label">
                      Alamat
                    </Label>
                    <Input name="alamat" id="alamat-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat ?? ""} invalid={validationMailing.touched.alamat && validationMailing.errors.alamat ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="atas_nama-field" className="form-label">
                      Atas Nama
                    </Label>
                    <Input name="atas_nama" id="atas_nama-field" className="form-control" placeholder="Isi Atas Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.atas_nama ?? ""} invalid={validationMailing.touched.atas_nama && validationMailing.errors.atas_nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kegiatan-field" className="form-label">
                      Kegiatan
                    </Label>
                    <Input name="kegiatan" id="kegiatan-field" className="form-control" placeholder="Isi Kegiatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kegiatan ?? ""} invalid={validationMailing.touched.kegiatan && validationMailing.errors.kegiatan ? true : false} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Luas Tanah
                    </Label>
                    <Input name="luas_tanah" id="luas_tanah-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.luas_tanah ?? ""} invalid={validationMailing.touched.luas_tanah && validationMailing.errors.luas_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="desa-field" className="form-label">
                      Desa
                    </Label>
                    <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.desa ?? ""} invalid={validationMailing.touched.desa && validationMailing.errors.desa ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kecamatan-field" className="form-label">
                      Kecamatan
                    </Label>
                    <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kecamatan ?? ""} invalid={validationMailing.touched.kecamatan && validationMailing.errors.kecamatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="telpon-field" className="form-label">
                      Telpon
                    </Label>
                    <Input name="telpon" id="telpon-field" className="form-control" placeholder="Isi Telpon" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.telpon ?? ""} invalid={validationMailing.touched.telpon && validationMailing.errors.telpon ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="email-field" className="form-label">
                      Email
                    </Label>
                    <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.email ?? ""} invalid={validationMailing.touched.email && validationMailing.errors.email ? true : false} />
                  </div>
                </div>
              </div>
            )}

            {dataPermisionModal && dataPermisionModal?.legalityDocumentId === 7 && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="nama-field" className="form-label">
                      Nama
                    </Label>
                    <Input name="nama" id="nama-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nama} invalid={validationMailing.touched.nama && validationMailing.errors.nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="perusahaan-field" className="form-label">
                      Perusahaan
                    </Label>
                    <Input name="perusahaan" id="perusahaan-field" className="form-control" placeholder="Isi Perusahaan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.perusahaan} invalid={validationMailing.touched.perusahaan && validationMailing.errors.perusahaan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jabatan-field" className="form-label">
                      Jabatan
                    </Label>
                    <Input name="jabatan" id="jabatan-field" className="form-control" placeholder="Isi Jabatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jabatan} invalid={validationMailing.touched.jabatan && validationMailing.errors.jabatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat-field" className="form-label">
                      Alamat
                    </Label>
                    <Input name="alamat" id="alamat-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat} invalid={validationMailing.touched.alamat && validationMailing.errors.alamat ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="ruas_jalan-field" className="form-label">
                      Ruas Jalan
                    </Label>
                    <Input name="ruas_jalan" id="ruas_jalan-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.ruas_jalan} invalid={validationMailing.touched.ruas_jalan && validationMailing.errors.ruas_jalan ? true : false} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="desa-field" className="form-label">
                      Desa
                    </Label>
                    <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.desa} invalid={validationMailing.touched.desa && validationMailing.errors.desa ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kecamatan-field" className="form-label">
                      Kecamatan
                    </Label>
                    <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kecamatan} invalid={validationMailing.touched.kecamatan && validationMailing.errors.kecamatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Luas Tanah
                    </Label>
                    <Input name="luas_tanah" id="luas_tanah-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.luas_tanah} invalid={validationMailing.touched.luas_tanah && validationMailing.errors.luas_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Tanggal
                    </Label>
                    <Flatpickr
                      className="form-control"
                      id="tanggal-input"
                      placeholder="Pilih Tanggal"
                      options={{
                        mode: "single",
                        dateFormat: "Y/m/d",
                      }}
                      onChange={(selectedDates, dateStr) => {
                        validationMailing.setFieldValue("tanggal", dateStr);
                      }}
                      value={validationMailing.values.tanggal ?? ""}
                    />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="no_lampiran-field" className="form-label">
                      Nomor Lampiran
                    </Label>
                    <Input name="no_lampiran" id="no_lampiran-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.no_lampiran} invalid={validationMailing.touched.no_lampiran && validationMailing.errors.no_lampiran ? true : false} />
                  </div>
                  {/* <div className="mb-3">
                    <Label htmlFor="jumlah_lampiran-field" className="form-label">
                      Jumlah Lampiran
                    </Label>
                    <Input name="jumlah_lampiran" id="jumlah_lampiran-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jumlah_lampiran} invalid={validationMailing.touched.jumlah_lampiran && validationMailing.errors.jumlah_lampiran ? true : false} />
                  </div> */}
                </div>
              </div>
            )}

            {dataPermisionModal && dataPermisionModal?.legalityDocumentId === 17 && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="nama-field" className="form-label">
                      Nama
                    </Label>
                    <Input name="nama" id="nama-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nama} invalid={validationMailing.touched.nama && validationMailing.errors.nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="perusahaan-field" className="form-label">
                      Perusahaan
                    </Label>
                    <Input name="perusahaan" id="perusahaan-field" className="form-control" placeholder="Isi Perusahaan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.perusahaan} invalid={validationMailing.touched.perusahaan && validationMailing.errors.perusahaan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jabatan-field" className="form-label">
                      Jabatan
                    </Label>
                    <Input name="jabatan" id="jabatan-field" className="form-control" placeholder="Isi Jabatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jabatan} invalid={validationMailing.touched.jabatan && validationMailing.errors.jabatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat-field" className="form-label">
                      Alamat
                    </Label>
                    <Input name="alamat" id="alamat-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat} invalid={validationMailing.touched.alamat && validationMailing.errors.alamat ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="akses_keluar_masuk-field" className="form-label">
                      Akses Keluar - Masuk
                    </Label>
                    <Input name="akses_keluar_masuk" id="akses_keluar_masuk-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.akses_keluar_masuk} invalid={validationMailing.touched.akses_keluar_masuk && validationMailing.errors.akses_keluar_masuk ? true : false} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="atas_nama-field" className="form-label">
                      Atas Nama
                    </Label>
                    <Input name="atas_nama" id="atas_nama-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.atas_nama} invalid={validationMailing.touched.atas_nama && validationMailing.errors.atas_nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="desa-field" className="form-label">
                      Desa
                    </Label>
                    <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.desa} invalid={validationMailing.touched.desa && validationMailing.errors.desa ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kecamatan-field" className="form-label">
                      Kecamatan
                    </Label>
                    <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kecamatan} invalid={validationMailing.touched.kecamatan && validationMailing.errors.kecamatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Tanggal
                    </Label>
                    <Flatpickr
                      className="form-control"
                      id="tanggal-input"
                      placeholder="Pilih Tanggal"
                      options={{
                        mode: "single",
                        dateFormat: "Y/m/d",
                      }}
                      onChange={(selectedDates, dateStr) => {
                        validationMailing.setFieldValue("tanggal", dateStr);
                      }}
                      value={validationMailing.values.tanggal ?? ""}
                    />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="no_lampiran-field" className="form-label">
                      Nomor Lampiran
                    </Label>
                    <Input name="no_lampiran" id="no_lampiran-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.no_lampiran} invalid={validationMailing.touched.no_lampiran && validationMailing.errors.no_lampiran ? true : false} />
                  </div>
                  {/* <div className="mb-3">
                    <Label htmlFor="jumlah_lampiran-field" className="form-label">
                      Jumlah Lampiran
                    </Label>
                    <Input name="jumlah_lampiran" id="jumlah_lampiran-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jumlah_lampiran} invalid={validationMailing.touched.jumlah_lampiran && validationMailing.errors.jumlah_lampiran ? true : false} />
                  </div> */}
                </div>
              </div>
            )}

            {dataPermisionModal && dataPermisionModal?.legalityDocumentId === 5 && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="nama-field" className="form-label">
                      Nama
                    </Label>
                    <Input name="nama" id="nama-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nama} invalid={validationMailing.touched.nama && validationMailing.errors.nama ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="ktp-field" className="form-label">
                      KTP
                    </Label>
                    <Input name="ktp" id="ktp-field" className="form-control" placeholder="Isi Telpon" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.ktp ?? ""} invalid={validationMailing.touched.ktp && validationMailing.errors.ktp ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="telpon-field" className="form-label">
                      Telpon
                    </Label>
                    <Input name="telpon" id="telpon-field" className="form-control" placeholder="Isi Telpon" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.telpon ?? ""} invalid={validationMailing.touched.telpon && validationMailing.errors.telpon ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="perusahaan-field" className="form-label">
                      Perusahaan
                    </Label>
                    <Input name="perusahaan" id="perusahaan-field" className="form-control" placeholder="Isi Perusahaan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.perusahaan} invalid={validationMailing.touched.perusahaan && validationMailing.errors.perusahaan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jabatan-field" className="form-label">
                      Jabatan
                    </Label>
                    <Input name="jabatan" id="jabatan-field" className="form-control" placeholder="Isi Jabatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jabatan} invalid={validationMailing.touched.jabatan && validationMailing.errors.jabatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat-field" className="form-label">
                      Alamat
                    </Label>
                    <Input name="alamat" id="alamat-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat} invalid={validationMailing.touched.alamat && validationMailing.errors.alamat ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat_perusahaan-field" className="form-label">
                      Alamat Perusahaan
                    </Label>
                    <Input name="alamat_perusahaan" id="alamat_perusahaan-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat_perusahaan} invalid={validationMailing.touched.alamat_perusahaan && validationMailing.errors.alamat_perusahaan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="no_perusahaan-field" className="form-label">
                      Nomor Akte Notaris
                    </Label>
                    <Input name="no_perusahaan" id="no_perusahaan-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.no_perusahaan} invalid={validationMailing.touched.no_perusahaan && validationMailing.errors.no_perusahaan ? true : false} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="nama_instansi-field" className="form-label">
                      Nama Instansi
                    </Label>
                    <Input name="nama_instansi" id="nama_instansi-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nama_instansi} invalid={validationMailing.touched.nama_instansi && validationMailing.errors.nama_instansi ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="alamat_instansi-field" className="form-label">
                      Alamat Instansi
                    </Label>
                    <Input name="alamat_instansi" id="alamat_instansi-field" className="form-control" placeholder="Isi Alamat" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.alamat_instansi} invalid={validationMailing.touched.alamat_instansi && validationMailing.errors.alamat_instansi ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="ruas_jalan-field" className="form-label">
                      Ruas Jalan
                    </Label>
                    <Input name="ruas_jalan" id="ruas_jalan-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.ruas_jalan} invalid={validationMailing.touched.ruas_jalan && validationMailing.errors.ruas_jalan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jenis_penggunaan_tanah-field" className="form-label">
                      Jenis Penggunaan Tanah
                    </Label>
                    <Input name="jenis_penggunaan_tanah" id="jenis_penggunaan_tanah-field" className="form-control" placeholder="Isi Ruas Jalan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jenis_penggunaan_tanah} invalid={validationMailing.touched.jenis_penggunaan_tanah && validationMailing.errors.jenis_penggunaan_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="desa-field" className="form-label">
                      Desa
                    </Label>
                    <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.desa} invalid={validationMailing.touched.desa && validationMailing.errors.desa ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kecamatan-field" className="form-label">
                      Kecamatan
                    </Label>
                    <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kecamatan} invalid={validationMailing.touched.kecamatan && validationMailing.errors.kecamatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Luas Tanah
                    </Label>
                    <Input name="luas_tanah" id="luas_tanah-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.luas_tanah} invalid={validationMailing.touched.luas_tanah && validationMailing.errors.luas_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Tanggal
                    </Label>
                    <Flatpickr
                      className="form-control"
                      id="tanggal-input"
                      placeholder="Pilih Tanggal"
                      options={{
                        mode: "single",
                        dateFormat: "Y/m/d",
                      }}
                      onChange={(selectedDates, dateStr) => {
                        validationMailing.setFieldValue("tanggal", dateStr);
                      }}
                      value={validationMailing.values.tanggal ?? ""}
                    />
                  </div>
                </div>
              </div>
            )}

            {dataPermisionModal && dataPermisionModal?.legalityDocumentId === 6 && (
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Tanggal
                    </Label>
                    <Flatpickr
                      className="form-control"
                      id="tanggal-input"
                      placeholder="Pilih Tanggal"
                      options={{
                        mode: "single",
                        dateFormat: "Y/m/d",
                      }}
                      onChange={(selectedDates, dateStr) => {
                        validationMailing.setFieldValue("tanggal", dateStr);
                      }}
                      value={validationMailing.values.tanggal ?? ""}
                    />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="nomor-field" className="form-label">
                      Nomor
                    </Label>
                    <Input name="nomor" id="nomor-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.nomor} invalid={validationMailing.touched.nomor && validationMailing.errors.nomor ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jalan-field" className="form-label">
                      Jalan
                    </Label>
                    <Input name="jalan" id="jalan-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jalan} invalid={validationMailing.touched.jalan && validationMailing.errors.jalan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="desa-field" className="form-label">
                      Desa
                    </Label>
                    <Input name="desa" id="desa-field" className="form-control" placeholder="Isi Desa" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.desa} invalid={validationMailing.touched.desa && validationMailing.errors.desa ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kecamatan-field" className="form-label">
                      Kecamatan
                    </Label>
                    <Input name="kecamatan" id="kecamatan-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kecamatan} invalid={validationMailing.touched.kecamatan && validationMailing.errors.kecamatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="kabupaten-field" className="form-label">
                      Kabupaten
                    </Label>
                    <Input name="kabupaten" id="kabupaten-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.kabupaten} invalid={validationMailing.touched.kabupaten && validationMailing.errors.kabupaten ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="provinsi-field" className="form-label">
                      Provinsi
                    </Label>
                    <Input name="provinsi" id="provinsi-field" className="form-control" placeholder="Isi Kecamatan" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.provinsi} invalid={validationMailing.touched.provinsi && validationMailing.errors.provinsi ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="luas_tanah-field" className="form-label">
                      Luas Tanah
                    </Label>
                    <Input name="luas_tanah" id="luas_tanah-field" className="form-control" placeholder="Isi Luas Tanah" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.luas_tanah} invalid={validationMailing.touched.luas_tanah && validationMailing.errors.luas_tanah ? true : false} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <Label htmlFor="utara-field" className="form-label">
                      Utara
                    </Label>
                    <Input name="utara" id="utara-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.utara} invalid={validationMailing.touched.utara && validationMailing.errors.utara ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="timur-field" className="form-label">
                      Timur
                    </Label>
                    <Input name="timur" id="timur-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.timur} invalid={validationMailing.touched.timur && validationMailing.errors.timur ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="selatan-field" className="form-label">
                      Selatan
                    </Label>
                    <Input name="selatan" id="selatan-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.selatan} invalid={validationMailing.touched.selatan && validationMailing.errors.selatan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="barat-field" className="form-label">
                      Barat
                    </Label>
                    <Input name="barat" id="barat-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.barat} invalid={validationMailing.touched.barat && validationMailing.errors.barat ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="status_tanah-field" className="form-label">
                      Status Tanah
                    </Label>
                    <Input name="status_tanah" id="status_tanah-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.status_tanah} invalid={validationMailing.touched.status_tanah && validationMailing.errors.status_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="jenis_tanah-field" className="form-label">
                      Jenis Tanah
                    </Label>
                    <Input name="jenis_tanah" id="jenis_tanah-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.jenis_tanah} invalid={validationMailing.touched.jenis_tanah && validationMailing.errors.jenis_tanah ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="dasar_penguasaan-field" className="form-label">
                      Dasar Penguasaan
                    </Label>
                    <Input name="dasar_penguasaan" id="dasar_penguasaan-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.dasar_penguasaan} invalid={validationMailing.touched.dasar_penguasaan && validationMailing.errors.dasar_penguasaan ? true : false} />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="rencana_pembangunan-field" className="form-label">
                      Rencana Pembangunan
                    </Label>
                    <Input name="rencana_pembangunan" id="rencana_pembangunan-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationMailing.handleChange} onBlur={validationMailing.handleBlur} value={validationMailing.values.rencana_pembangunan} invalid={validationMailing.touched.rencana_pembangunan && validationMailing.errors.rencana_pembangunan ? true : false} />
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button type="button" className="btn btn-light" onClick={toggleMailing}>
                Tutup
              </button>
              <button type="submit" className="btn btn-success">
                <span className="d-flex align-items-center">
                  <span className="flex-grow-1 me-2">Simpan</span>
                  {loading && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </button>
            </div>
          </div>
        </Form>
      </Modal>

      <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
        <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
          TAGIHAN {info?.name}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationAccPayable.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <div className="mb-3 col-lg-4">
                <Label htmlFor="amount-field" className="form-label">
                  Jumlah
                </Label>
                <CurrencyInput
                  id="amount"
                  name="amount"
                  prefix="Rp. "
                  style={{ border: "1px solid #ccc" }}
                  className="form-control product-price"
                  placeholder="Terbayar"
                  value={validationAccPayable.values.amount}
                  decimalsLimit={2}
                  onFocus={(e) => e.target.select()}
                  onValueChange={(value, name, values) => {
                    let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                    validationAccPayable.setFieldValue("amount", parseFloat(value));
                  }}
                />
                {validationAccPayable.touched.amount && validationAccPayable.errors.amount && (
                  <p className="invalid-feedback d-block" type="invalid">
                    {validationAccPayable.errors.amount}
                  </p>
                )}
              </div>
              <div className="mb-3 col-lg-4">
                <Label htmlFor="amount-field" className="form-label">
                  Tanggal Tagihan
                </Label>
                <Flatpickr
                  className="form-control"
                  id="datepicker-publish-input"
                  placeholder="Select transaction date"
                  options={{
                    mode: "single",
                    dateFormat: "Y/m/d",
                  }}
                  onChange={(selectedDates, dateStr) => {
                    validationAccPayable.setFieldValue("transactionat", dateStr);
                  }}
                  value={validationAccPayable.values.transactionat ?? ""}
                />
              </div>
              <div className="mb-3 col-lg-4">
                <Label className="form-label">Cashflow</Label>
                <Select
                  name="cashflow"
                  value={validationAccPayable.values.cashflow}
                  placeholder="Pilih Cashflow"
                  onChange={(e) => {
                    validationAccPayable.setFieldValue("cashflow", e);
                  }}
                  options={budgetList}
                ></Select>
                {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                  <small className="text-danger" type="invalid">
                    {validationAccPayable.errors.cashflow}
                  </small>
                )}
              </div>
              <div className="mb-3">
                <Label htmlFor="address-field" className="form-label">
                  Keterangan
                </Label>
                <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                  <small className="text-danger" type="invalid">
                    {validationAccPayable.errors.description}
                  </small>
                )}
              </div>
            </div>
          </ModalBody>
          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalAccPayable(false);
                  validationAccPayable.resetForm();
                }}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                <span className="d-flex align-items-center">
                  <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                  {loading && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </button>
            </div>
          </div>
        </Form>
      </Modal>

      <Modal id="showModalPrint" isOpen={modalPrint} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={togglePrint}>
          {`View ${printType}`}
        </ModalHeader>
        {dataPermisionModal && (
          <>
            <PrintDocF4 innerRef={printRef} item={dataPermisionModal?.mailing} type={printType} />
          </>
        )}

        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={togglePrint}>
              TUTUP
            </button>
            {<ButtonPrintF4 innerRef={printRef} title={`${printType}-${dataPermisionModal?.mailing?.kategori_perizinan?.label ?? ""}`} />}
          </div>
        </div>
      </Modal>

      {/* /// */}
      <Modal id="showModal" isOpen={modalTrans} centered size="xl">
        <ModalHeader className="bg-light p-3" toggle={toggleTrans}>
          {info?.material_name ?? ""}
        </ModalHeader>
        <ModalBody>
          <CardBody>
            <div>
              <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                <div className="col-sm-10">
                  <Row className="m-0 p-0 ">
                    <div className="fw-semibold  text-start">
                      <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchListTrans(e.target.value)} />
                    </div>
                  </Row>
                </div>
                <div className="col-sm-2 text-end">
                  <ExportDoc data={printTransDoc} />
                </div>
              </Row>
              <SimpleBar style={{ height: "450px" }}>
                <Table className="table-border text-center table-hover">
                  <thead className="align-middle">
                    <tr className="table-active">
                      <td style={{ width: "20px" }}>
                        <input
                          type="checkbox"
                          className="checkboxDetailAll me-2 form-check-input"
                          checked={expense.every((item) => item.isChecked)}
                          onChange={() => {
                            const allChecked = expense.every((item) => item.isChecked);
                            const updatedData = expense.map((item) => ({
                              ...item,
                              isChecked: !allChecked,
                            }));
                            setExpense(updatedData);
                          }}
                        />
                      </td>
                      <td className="text-center" style={{ width: "100px" }}>
                        No Transaksi
                      </td>
                      <td className="text-center" style={{ width: "80px" }}>
                        Tanggal
                      </td>
                      <td className="text-center" style={{ width: "80px" }}>
                        Jenis
                      </td>
                      <td className="text-right" style={{ width: "170px" }}>
                        Tag
                      </td>
                      <td className="text-right" style={{ width: "170px" }}>
                        Jumlah
                      </td>
                      <td className="text-center" style={{ width: "200px" }}>
                        Keterangan
                      </td>
                    </tr>
                  </thead>
                  <tbody id="newlink">
                    {(expense || []).map((o, i) => {
                      let type;
                      switch (o.type) {
                        case "CASH IN":
                          type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                          break;
                        case "RECEIVABLE":
                          type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                          break;
                        case "CASH OUT":
                          type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                          break;
                        case "PAYABLE":
                          type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                          break;
                        default:
                          type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                          break;
                      }
                      return (
                        // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                        <tr key={i}>
                          <td style={{ verticalAlign: "middle", width: "30px" }}>
                            <div className="hstack gap-2 mt-4 mt-sm-0">
                              <input
                                type="checkbox"
                                className="checkboxDetail me-2 form-check-input"
                                checked={o.isChecked}
                                onChange={() => {
                                  const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                  setExpense(updatedData);
                                }}
                              />
                            </div>
                          </td>
                          {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                          <td className="text-center" style={{ verticalAlign: "middle" }}>
                            {o.transaction_no}
                            {o.statusId === 4 && (
                              <p className="mb-1">
                                <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                              </p>
                            )}
                            {o.statusId === 3 && (
                              <p className="mb-1">
                                <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                              </p>
                            )}
                            {o.statusId === 2 && (
                              <p className="mb-1">
                                <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                              </p>
                            )}
                            {o.statusId === 1 && (
                              <p className="mb-1">
                                <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                              </p>
                            )}
                          </td>
                          <td className="text-center" style={{ verticalAlign: "middle" }}>
                            {handleValidDate(o.transactionat)}
                          </td>
                          <td className="text-center" style={{ verticalAlign: "middle" }}>
                            {type}
                          </td>
                          <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                            {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                          </td>
                          <td className="text-center" style={{ verticalAlign: "middle" }}>
                            {currencyFormat(o.amount)}
                          </td>
                          <td className="text-left" style={{ verticalAlign: "middle" }}>
                            {o.description}
                          </td>
                        </tr>
                      );
                    })}

                    {expense.length === 0 && (
                      <tr>
                        <td colSpan="7" className="p-3 text-center">
                          Belum ada realisasi
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </SimpleBar>
              <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                <div className="col-sm-6 fs-12 text-start">
                  HUTANG:
                  <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                    {currencyFormat(
                      (expense || [])
                        .filter((el) => el.type === "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                        .map((el) => parseFloat(el.amount || 0))
                        .reduce((prev, curr) => prev + curr, 0)
                    )}
                  </span>
                </div>
                <div className="col-sm-6 fs-12 text-end">
                  PEMBAYARAN KAS / BANK :
                  <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                    {currencyFormat(
                      (expense || [])
                        .filter((el) => el.type !== "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                        .map((el) => parseFloat(el.amount || 0))
                        .reduce((prev, curr) => prev + curr, 0)
                    )}
                  </span>
                </div>
              </Row>
            </div>
          </CardBody>
        </ModalBody>
      </Modal>

      <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
    </React.Fragment>
  );
};

export default LegalPermission;
